import { TranslationKey } from '../../../../../types/translation/TranslationKey';

import React, { useContext } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { ProductMasterDataContext } from '../../../../../context/ProductMasterDataContext';
import InnerFilterContent, { FilterInnerContentProps } from '../../common/DropdownContent/DynamicFilterInnerContent';
import { Asset } from '../../../../../types/asset/asset';

export default function AssetFilterInnerContent({
  filter,
  filterProps,
  setFilterProps,
}: FilterInnerContentProps<Asset>) {
  const { productMasterData } = useContext(ProductMasterDataContext);

  return (
    <InnerFilterContent
      filter={filter}
      filterProps={{ filterProps, setFilterProps }}
      items={[...(filterProps.product || [])]}
      text={item => productMasterData.get(item)?.productName || t(TranslationKey.unknownProduct).singular.label}
      onRemove={i => {
        filterProps.product?.delete(i);
        if (!filterProps.product?.size) filterProps.product = undefined;
        setFilterProps({ ...filterProps });
      }}
    />
  );
}
